import React from 'react';
import { FaRegCheckCircle } from "react-icons/fa";

const CustomDialog = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-end z-50 pb-[10%]">
      <div className="bg-white p-6 rounded-lg shadow-lg mb-8 w-96 text-center">
        <div className="flex justify-center items-center mb-4">
          <FaRegCheckCircle size={100} className="text-green-600" />
        </div>
        <p className="text-lg">{message}</p>
        <button
          className="mt-4 px-6 py-1 bg-green-500 text-white rounded-md hover:bg-green-600 transition"
          onClick={onClose}
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default CustomDialog;
